<template>
    <div
      class="modal fade createNewModal"
      id="AddElementModal"
      tabindex="-1"
      ref="addElementModalRef"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
                
                <div class="row">

                  <div class="col-md-3">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                          Date
                      </label>
                      <Field name="dateReglement" type="date"  :value="getCurrentDate()"
                      class="form-control shadow-none fs-md-15 text-black"/>
                      <ErrorMessage name="dateReglement" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-9">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Client <span class="text-danger">*</span>
                      </label>
                      <Field name="vente" v-model="clientSelected"  v-slot="{ field }">
                        <Multiselect
                            v-model = "field.value"
                            v-bind = "field"
                            :options="venteOptions"
                            :searchable="true"
                            @input="getVenteData($event)"
                            placeholder="Rechercher un element"
                            noResultText= "Aucun enregistrement trouvé"
                            noOptionsText="Tapez au moins deux caractères"/>
                      </Field>
                      <ErrorMessage name="vente" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-4">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Montant Du <span class="text-danger">*</span>
                      </label>
                      <Field name="montantDu" type="text" readonly="true" v-model="montantDu"
                      disabled="true"
                      class="form-control shadow-none fs-md-15 text-black" placeholder=""/>
                      <ErrorMessage name="montantDu" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-4">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        montant payer <span class="text-danger">*</span>
                      </label>
                      <Field name="montant" type="text" v-model="montantAPayer"
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le code"/>
                      <ErrorMessage name="montant" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-4">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Reste a payer <span class="text-danger">*</span>
                      </label>
                      <Field name="restAPayer" type="text" readonly="true" v-model="restAPayer"
                      disabled="true"
                      class="form-control shadow-none fs-md-15 text-black" placeholder=""/>
                      <ErrorMessage name="restAPayer" class="text-danger"/>
                  </div>
                  </div>

                  

                  

                </div>
                
              
              <button v-if="estOk"
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit"
                :disabled="isSubmitting"
                            >
                    <span v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span v-else>{{ btntext }}</span>
                
              </button>
          </Form>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="resetValue()"
          ></button>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, watch, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from '../../services/ApiService';
  import * as Yup from 'yup';
  import { Reglement } from '../../models/Reglement';
  import { Vente } from '../../models/Vente';
  import { error , success, hideModal } from '../../utils/utils';
  import Multiselect from '@vueform/multiselect';
  
  export default defineComponent({
      name: "AddReglementModal",
      components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect
    },
    props: {
      item: {
        type: Number,
        default: 0,
      }
    },
    setup(props, { emit }){
      const elementSchema = Yup.object().shape({
        vente: Yup.number().required('La vente est obligatoire'),
        dateReglement: Yup.date().required('La date est obligatoire'),
        montant: Yup.string().required('Le montant est obligatoire'),
        restAPayer: Yup.string().required('Le reste à payer est obligatoire'),
        montantDu: Yup.string().required('Le montant du est obligatoire'),
      });
  
      
      const elementForm = ref<Reglement | null>(null);
      const addElementModalRef = ref<null | HTMLElement>(null);
      const sexeSelected = ref(null);
      const clientSelected = ref(null);
      const venteOptions = ref([]);
      const venteOptions__ = ref([]);
      const montantAPayer = ref(0);
      const restAPayer = ref(0);
      const montantDu = ref(0);
      const estOk = ref(false);

      const montantVente = ref(0);
      const totalDejaPayer = ref(0);

      
      const isUPDATE = ref(false);
      const title = ref("Ajouter un reglement");
      const btntext = ref('Enregister');
      const isSubmitting = ref(false);
  
      watch(() => props.item, (newValue) => {
        getOne(newValue);
        isUPDATE.value = true;
        btnTitle();
        console.log('item',newValue);
      });
  
      const btnTitle = async () => {
        if (isUPDATE.value) {
           title.value = "Modifier le reglement";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter un reglement";
           btntext.value = "Enregister";
        }
      }
  
      const produitsError = ref(false); 

      const getVenteData = async (val) => {
        const vente : any = venteOptions__.value.filter((p : any) => { 
          return p.id == val;
        });
        isSubmitting.value = false;
        console.log('yes', vente[0].mise);
        // montantAPayer.value = vente[0].mise;
        montantDu.value = parseFloat(vente[0].montant) - parseFloat(vente[0].totalPayer);
        restAPayer.value = parseFloat(vente[0].montant) - parseFloat(vente[0].totalPayer);
        montantVente.value = parseFloat(vente[0].montant);
        totalDejaPayer.value = parseFloat(vente[0].totalPayer);
      }

      watch(montantAPayer, (newValue) => {
        restAPayer.value = montantVente.value - totalDejaPayer.value - parseFloat(newValue.toString());
        console.log('resteAPayer',restAPayer.value);
        if(newValue > 0){
          estOk.value = true;
        }else{
          estOk.value = false;
        }
      });
      

      const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${year}-${month}-${day}`;
      }

      const fetchVentesAttente = async () => {
          ApiService.get("/ventes/nonregler?limit=-1")
          .then(({ data }) => {
            console.log("yes",data);
            venteOptions__.value = data.data.data;
            venteOptions.value = data.data.data.map((p) => {
              return { 
              value: p.id,
              label: '[ '+p.client.code+' ] '+p.client.nom+' '+ p.client.prenoms+' - '+p.montant+' F CFA',
              }
          });
          })
          .catch(({ response }) => {
          // produitsError.value = true;
          });
      };
     
      const getOne = async (id: number) => {
        return ApiService.get("/reglement/"+id)
        .then(({ data }) => {
          // map data in form
          const donnees = data.data;
          for (const key in donnees) {
            elementForm.value?.setFieldValue(key, 
            (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
            );
          }
          emit('openmodal', addElementModalRef.value);
  
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }

  
      const addElement = async (values: any, elementForm) => {
        isSubmitting.value = true;

        console.log("mon form",values);
        values = values as Reglement;
        if(isUPDATE.value){
          ApiService.put("/reglement/"+values.id,values)
          .then(({ data }) => {
              if(data.code == 200) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                isUPDATE.value=false;
                btnTitle();
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }else{
          console.log('values',values);
          ApiService.post("/reglement",values)
          .then( async ({ data }) => {
              if(data.code == 201) { 
                success(data.message);

                ApiService.get("/reglements/agent")
                .then(({ data }) => {
                  console.log("yesqs",data.data.data);
                });

                elementForm.resetForm();
                await fetchVentesAttente(); //ici
                // ApiService.get("/reglements/agent");
                hideModal(addElementModalRef.value);
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
              hideModal(addElementModalRef.value);
              emit('close');
          });
        }
      };
     
  
      onMounted(() => {
        fetchVentesAttente();
      });
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
          isUPDATE.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle();
      };
  
      return { 
        elementSchema,
        addElementModalRef,
        addElement,
        getCurrentDate,
        elementForm,
        title,btntext,
        resetValue,
        produitsError,
        sexeSelected,
        clientSelected,
        venteOptions,
        montantAPayer,
        restAPayer,
        montantDu,
        getVenteData,
        estOk,
        isSubmitting
      };
      
    },
  });
  </script>